import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import { getHasUnreadMessages, getHasUnreadInboxItems, getHasUnreadFinances } from './../store/notification/selectors'

import classNames from './../utils/classNames';
import { clearToken } from './../utils/tokenStorage';
import { urls } from './../config';

import Nav from './Nav';
import Icon from './Icon';
import Dropdown from './Dropdown';

const onLogout = () => {
    clearToken();
    window.location.href = urls.logout;
};

class MainNav extends Component {
    constructor(props) {
        super(props);

        this.onProfileClick = this.onProfileClick.bind(this);
    }

    onProfileClick(event) {
        event.preventDefault();
        const { location, history } = this.props;
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.has('profile')) {
            return;
        }
        const searchFromParams = searchParams.toString();
        const newSearch = !searchFromParams ? ('?profile') : `?${searchFromParams}&profile`;
        history.push(location.pathname + newSearch);
    }

    render() {
        const { hasNewMessges, hasNewInboxItems, hasNewFinances } = this.props;
        const ordersClassName = classNames({ 'new': hasNewMessges });
        const inboxClassName = classNames({ 'new': hasNewInboxItems });
        const financesClassName = classNames({ 'new': hasNewFinances });
        return (
            <div>
                <Nav>
                    <NavLink to="/findorders">Find Orders</NavLink>
                    <NavLink className={ordersClassName} to="/myorders">My Orders</NavLink>
                    <NavLink className={inboxClassName} to="/inbox">Inbox</NavLink>
                    <NavLink className={financesClassName} to="/finances">Finances</NavLink>
                    <NavLink to="/help">Help</NavLink>
                </Nav>

                <div className="personal-info container">
                    <div className="personal-box">
                        <Dropdown closeAlways icon="user" className="" btnClassName="">
                            <ul className="menu menu-selectable">
                                <li className="menu-item">
                                    <a onClick={this.onProfileClick}>
                                        <Icon className="svg-icon" iconName="settings" />
                                        Profile settings
                                    </a>
                                </li>
                                <li className="menu-item">
                                    <a onClick={onLogout}>
                                        <Icon className="svg-icon" iconName="logout" />
                                        Logout
                                    </a>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const hasNewMessges = getHasUnreadMessages(state);
    const hasNewInboxItems = getHasUnreadInboxItems(state);
    const hasNewFinances = getHasUnreadFinances(state);
    return { hasNewMessges, hasNewInboxItems, hasNewFinances };
};

export default connect(mapStateToProps)(MainNav);



// WEBPACK FOOTER //
// ./src/components/MainNav.js